import {apiService} from "../api.service";

export class SettingsService {

    public async update(values: {timezone: string}): Promise<void> {
        await apiService.post("settings", values);
    }
}

export const settingsService = new SettingsService();